import { Grid, Box, Typography, CircularProgress } from '@mui/material'
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby3 from "../../images/babby3.png"
import baby2 from "../../images/baby3.png"
import baby4 from "../../images/babby4.png"
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAccountProfileAuthQuery } from '../../features/Auth/authApi'
import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { useAppDispatch } from '../../app/store'
import { onBoardKey, userDetails } from '../../features/Auth/authSlice'
import { setString } from '../../features/Auth/WrapperSlice'
const VerifyGoogle = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const hasRun = useRef(false);
  const access_token = searchParams.get('access_token')

  const isKey = searchParams.get('key')
  const name = searchParams.get('name') || ''
  const email = searchParams.get('email') || ''
  const _id = searchParams.get('id') || ''

  const { data, error, isSuccess, isUninitialized } = useAccountProfileAuthQuery({
    token: access_token

  }, {
    skip: !access_token || isKey === "false",
    refetchOnMountOrArgChange: true
  })

  useEffect(() => {
    if (isKey === 'false' && !hasRun.current) {
    dispatch(setString({}))
    dispatch(onBoardKey("onboardingroute" as any))
    dispatch(userDetails({user: {name, email, _id, signUpWith: "Google"}} as any))
    toast.error("Please Complete your profile")
    navigate("/provider-onboarding", { replace: true})
    hasRun.current = true;
  }
  }, [isKey, dispatch, navigate, name, email, _id])

  return (
    <>
      <Grid container justifyContent="center">
        <Grid
          item
          lg={6}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box className="Imgbox" display="flex" flexWrap="wrap" gap={2}>
              <Box><img src={baby1} /></Box>
              <Box mt={5}><img src={baby2} /></Box>
              <Box><img src={baby3} /></Box>
              <Box mt={5}><img src={baby4} /></Box>
            </Box>
          </Box>
        </Grid>

        <Grid item lg={6}>
          <Box className="Loginform">
            <Typography
              variant="h4"
              mt={5}
              fontFamily="Montserrat"
              fontSize={22}
              fontWeight="600"
              color="pink.main"
              textAlign="center"
            >
              Google Authentication
            </Typography>
            <Typography
              sx={{
                color: "#7B7B7B",
                margin: "8px 0 0 13px",
                textAlign: "center",
              }}
            >
              {!isSuccess ? (
                <>
                  <CircularProgress size={20} style={{ marginRight: 10 }} />
                  Verifying...
                </>
              ) : (
                "Redirecting to dashboard..."
              )}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default VerifyGoogle